import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './TestimonialsSlider.css';

const TestimonialsSlider = ({ reviews }) => {
  const itemsPerSlide = 3;
  const totalSlides = Math.ceil(reviews.length / itemsPerSlide);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Group reviews into slides of 3
  const groupedReviews = [];
  for (let i = 0; i < reviews.length; i += itemsPerSlide) {
    groupedReviews.push(reviews.slice(i, i + itemsPerSlide));
  }

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === totalSlides - 1 ? 0 : prevSlide + 1
      );
    }, 6000); // Change every 6 seconds

    return () => clearInterval(interval);
  }, [totalSlides, isAutoPlaying]);

  const goToPrevious = () => {
    setIsAutoPlaying(false);
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? totalSlides - 1 : prevSlide - 1
    );
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentSlide((prevSlide) =>
      prevSlide === totalSlides - 1 ? 0 : prevSlide + 1
    );
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentSlide(index);
  };

  return (
    <div className="testimonials-slider">
      <div className="testimonials-slider-container">
        {/* Navigation Arrows */}
        <button
          className="testimonials-slider-btn testimonials-slider-btn-prev"
          onClick={goToPrevious}
          aria-label="المراجعة السابقة"
        >
          <FaChevronRight />
        </button>

        <button
          className="testimonials-slider-btn testimonials-slider-btn-next"
          onClick={goToNext}
          aria-label="المراجعة التالية"
        >
          <FaChevronLeft />
        </button>

        {/* Slides */}
        <div className="testimonials-slides-wrapper">
          {groupedReviews.map((slideReviews, slideIndex) => (
            <div
              key={slideIndex}
              className={`testimonials-slide ${
                slideIndex === currentSlide ? 'active' : ''
              }`}
            >
              <div className="testimonials-slide-grid">
                {slideReviews.map((review) => (
                  <div key={review.id} className="testimonials-slide-content">
                    <div className="testimonials-slide-header">
                      <div className="testimonials-rating">
                        {'⭐'.repeat(review.rating)}
                      </div>
                      <div className="testimonials-quote-icon">"</div>
                    </div>

                    <p className="testimonials-slide-text">{review.text}</p>

                    <div className="testimonials-slide-author">
                      <div className="testimonials-author-info">
                        <h5 className="testimonials-author-name">{review.authorName}</h5>
                        <p className="testimonials-author-title">{review.authorTitle}</p>
                        {review.location && (
                          <p className="testimonials-author-location">📍 {review.location}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Dots Navigation */}
        <div className="testimonials-slider-dots">
          {groupedReviews.map((_, index) => (
            <button
              key={index}
              className={`testimonials-slider-dot ${
                index === currentSlide ? 'active' : ''
              }`}
              onClick={() => goToSlide(index)}
              aria-label={`الانتقال إلى المجموعة ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSlider;
